// extracted by mini-css-extract-plugin
module.exports = {"slider-root":"style_slider-root__mlEHH"};